import ApiClient from './ApiClient'

const API_NAME = 'WeConnect'
const BASE_PATH = 'static'

const client = new ApiClient(API_NAME)

export default {
  get(id) {
    return client.get(`/${BASE_PATH}/${id}`)
  }
}
